var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_",
    "data-name": "$",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.509,
    height: 103.312,
    viewBox: "0 0 56.509 103.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M56.509,27.032c-8.75,1.69-45.246,9.778-43.663,20.863.023.017-.024.04.029.07.1.055.054.13.217.23a1.634,1.634,0,0,1,.165.158c.106.091.387.261.51.364l.347.185c3.707,1.85,8.154,2.358,12.5,3.115,4.83.786,9.941,1.428,14.8,2.972,12.01,3.412,14.26,14.891,3.043,21.219a63.524,63.524,0,0,1-14.435,5.762A194.47,194.47,0,0,1,1.046,87.547L0,79.234C12.023,77.3,24.924,74.985,36.111,70.45c2.35-1.02,5.608-2.624,6.735-4.455C41.209,62.671,29.181,61.372,25.2,60.55,20.15,59.607,14.8,58.9,9.949,56.261A14.544,14.544,0,0,1,7.822,54.8c-5.456-4.472-3.812-12.632.67-17.176C17.349,28.6,34.075,25.159,46.113,23.142c3.236-.5,6.427-.927,9.742-1.19Z",
    transform: "translate(0 -3.56)",
    fill: "#738bff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M44.9,3.034c-7.5,24.287-12.207,49.586-15.441,74.8C28.35,86.3,27.587,94.8,26.862,103.312l-6.635-.4c.509-10.718,1.294-21.666,2.388-32.36A492.054,492.054,0,0,1,32.053,12.8c1-4.33,2.015-8.467,3.26-12.8L44.9,3.034",
    transform: "translate(-3.281)",
    fill: "#738bff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.cde475ec98713b00e057ff82f2fef57f.svg";
export { ForwardRef as ReactComponent };